import gql from 'graphql-tag';

export const GET_ADMIN_LISTINGS = gql`
	query GetAdminListings($order: [[String]], $query: JSON, $limit: Int, $offset: Int) {
		listings(order: $order, query: $query, limit: $limit, offset: $offset) {
			id
			createdAt
			client {
				id
				name
				image
			}
			coverFile {
				id
				type
				filename
				thumbnailUrl
				webUrl
				printUrl
				originalUrl
				width
				height
			}
			property {
				id
				unitNumber
				address
				addressComponents
				alias
				baths
				beds
				city
				country
				googlePlaceId
				latitude
				longitude
				state
				streetAddress
				squareFootage
				timezone
				type
				unitNumber
				yearBuilt
				zipCode
			}
			updatedAt
			type
			status
			askingPrice
			squareFootage
			lotSize
			beds
			baths
			neighborhoodDescription
			homeDescription
			yearBuilt
			services {
				id
				type
				status
				serviceDate
				isActive
				bookedOptions {
					id
					name
					quantity
				}
			}
		}
	}
`;
